export const ErrorMessages = {
  "400": "Oops! Unqualified technical error. Contact us with this code: 400",
  "401":
    "vads_order_id can be alphanumeric only, no special characters allowed (Size : 1 to 64)",

  "402": "vads_amount should be numeric and equal or greater than 100",
  "403": "vads_currency should be in INR",

  "404": "vads_site_id should have a size between 1 and 8",

  "405":
    "vads_action_mode is mandatory (Accepted values are INTERACTIVE, IFRAME)",

  "406": "vads_version is mandatory (Accepted Value is V2)",

  "407": "Incorrect signature",

  "408":
    "vads_payment_option_code is not mapped to any relevant payment option",

  "409": "vads_return_mode shoud be either GET or POST or NONE only.",

  "410": "Shop - Id passed is either Invalid or Shop does not exist",

  "411": "vads_redirect_success_timeout should be positive integers",

  "412": "vads_redirect_error_timeout should be positive integers",

  "413": "vads_cust_email validation failed !",

  "414": "Production charge creation is not allowed on TEST mode shop",

  "415":
    "vads_url_check should contain a valid URL starting with http or https, and with a maximum of 250 characters.",

  "428":
    "Incorrect format of vads_cust_cell_phone. Allowed formats (with max length 32): 0123456789, 022 123456, (022) 123456, +91123456789, +91 9999999999",

  "427": "vads_cust_name can be alhanumeric only with max length 32.",

  "422":
    "Incorrect format of vads_cust_phone. Allowed formats (with max length 32): 0123456789, 022 123456, (022) 123456, +91123456789, +91 9999999999",

  "417":
    "Incorrect format of vads_cust_city. Only aphabets with size between 0 and 128 are allowed.",

  "418":
    "Incorrect format of vads_cust_state. Only alphabets with size between 0 and 127 are allowed. ",

  "419":
    "Incorrect format of vads_cust_zip. Only numbers with size between 0 and 64 are allowed.",

  "420":
    "Incorrect format for vads_cust_country. It must comply with the ISO 3166 standard. For ex. IN ",

  "426":
    "Incorrect format for vads_cust_id. It should contain at most 63 alphanumerical characters, for example: CUST0001.",

  "421":
    "vads_url_return should contain a valid URL starting with http or https, and with a maximum of 250 characters.",

  "423":
    "Incorrect format for vads_order_info. It should contain at most 255 alphanumerical characters, for example: sample order info for order number 12",

  "425":
    "Incorrect format for vads_convenience_fee. Only numerical values are allowed. For example: 220, 22.50",

  "424":
    "Incorrect format for vads_trans_id. It should contain at most 6 alphanumerical characters. For example: Tr123",

  "429":
    "Incorrect format for vads_cust_first_name. This field has a maximum length of 63 characters and contains only alphabets.",

  "430":
    "Incorrect format for vads_cust_last_name. This field has a maximum length of 63 characters and contains only alphabets."
};

export const getErrorMessage = code => {
  return ErrorMessages[code];
};
